export const pathSupportMain = "main";
